import { withFields } from 'app-webtech-core/beacon/withFields';
import { LOGIN_WITH_EMAIL, LOGOUT, REGISTER_WITH_EMAIL } from '../actions/types';
import { signInBeacon } from './signIn';
import { signOutBeacon } from './signOut';
import { signUpBeacon } from './signUp';

export const userAccountEventDefinitionsMap = {
  [REGISTER_WITH_EMAIL.SUCCESS]: withFields(signUpBeacon),
  [LOGIN_WITH_EMAIL.SUCCESS]: withFields(signInBeacon),
  [LOGOUT.SUCCESS]: withFields(signOutBeacon),
};
